export const NOTIFICATION_TYPES = {
    GET_NON_OPENED_NOTIFICATIONS_COUNT: "non-opened-notifications-count",
    SET_ALL_NOTIFICATIONS_OPENED: "set-all-notifications-opened",
    REMOVE_ALL_NOTIFICATIONS: "remove-all-notifications",
    REMOVE_NOTIFICATION: "remove-notification",

    GET_NOTIFICATION_LIST: "get-notification-list",
};